import { Injectable } from '@angular/core';
import { SkillService } from 'src/app/services/api/skill/skill.service';

@Injectable()
export class SkillEffects {
  constructor(private skillService: SkillService) {}
}
